/**
 * LP BTC Products — cart JS
 * Handles add-to-cart, quantity stepper, cart drawer refresh and count sync.
 */

/* ── Utilities ── */

function lpGetCartUrl() {
  return window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
}

function lpGetSectionsToRender() {
  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
    return cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
  }
  return ['cart-icon-bubble', 'cart-drawer'];
}

function lpFindCartItem(cart, variantId) {
  if (!cart || !cart.items) return null;
  variantId = Number(variantId);
  return cart.items.find(function (item) {
    return Number(item.variant_id) === variantId;
  }) || null;
}

/* ── UI helpers ── */

function lpSetProductQuantityUI(variantId, quantity) {
  document.querySelectorAll('[data-lp-cart-controls]').forEach(function (control) {
    if (Number(control.getAttribute('data-variant-id')) !== Number(variantId)) return;

    var addButton   = control.querySelector('.lp-btc-card__atc, .lp-product-card__cta');
    var qtyControls = control.querySelector('[data-lp-qty-controls]');
    var qtyValue    = control.querySelector('[data-lp-qty-value]');

    if (!addButton || !qtyControls || !qtyValue) return;

    if (quantity > 0) {
      addButton.hidden    = true;
      qtyControls.hidden  = false;
      qtyValue.textContent = quantity;
    } else {
      addButton.hidden    = false;
      qtyControls.hidden  = true;
      qtyValue.textContent = '0';
    }
  });
}

function lpSetProductControlsLoading(control, isLoading) {
  if (!control) return;
  var qtyDiv = control.querySelector('[data-lp-qty-controls]');
  if (qtyDiv) qtyDiv.classList.toggle('lp-loading', isLoading);
  control.querySelectorAll('button').forEach(function (btn) {
    btn.disabled = isLoading;
  });
}

function lpSyncProductQuantities(cart) {
  if (!cart || !cart.items) return;

  var quantitiesByVariant = {};
  cart.items.forEach(function (item) {
    var vid = Number(item.variant_id);
    quantitiesByVariant[vid] = (quantitiesByVariant[vid] || 0) + item.quantity;
  });

  document.querySelectorAll('[data-lp-cart-controls]').forEach(function (control) {
    var variantId = Number(control.getAttribute('data-variant-id'));
    lpSetProductQuantityUI(variantId, quantitiesByVariant[variantId] || 0);
  });
}

/* ── Cart count ── */

function lpUpdateCartCount(count, sectionHTML) {
  if (sectionHTML) {
    var bubbleDoc = new DOMParser().parseFromString(sectionHTML, 'text/html');
    var newIconBubble      = bubbleDoc.querySelector('#cart-icon-bubble');
    var existingIconBubble = document.querySelector('#cart-icon-bubble');
    if (newIconBubble && existingIconBubble) {
      existingIconBubble.innerHTML = newIconBubble.innerHTML;
    }
  }

  document.querySelectorAll('#lp-header-cart-count').forEach(function (el) {
    el.textContent = count;
    el.setAttribute('aria-hidden', count > 0 ? 'false' : 'true');
  });

  if (document.querySelector('#lp-header-cart-count')) {
    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) { bubble.remove(); });
  }

  document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
    if (count > 0) {
      var hiddenCount    = bubble.querySelector('[aria-hidden]');
      var accessibleText = bubble.querySelector('.visually-hidden');
      if (hiddenCount)    hiddenCount.textContent    = count;
      if (accessibleText) accessibleText.textContent = count + (count === 1 ? ' item' : ' items');
      bubble.removeAttribute('hidden');
    } else {
      bubble.remove();
    }
  });

  document.querySelectorAll('[data-cart-count]').forEach(function (el) {
    el.textContent = count;
  });

  document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: count } }));
}

/* ── Discount incentive banner ── */

function lpEscapeHTML(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/* Spread nodes visually between 15% and 90% so labels never overflow the bar */
function lpGetVisualPositions(tiers) {
  var n = tiers.length;
  if (n === 1) return [50];
  return tiers.map(function (_, i) {
    return parseFloat((15 + (i / (n - 1)) * 75).toFixed(1));
  });
}

/* Fill tracks visual node positions so the bar meets each node exactly */
function lpGetFillPct(cartCount, tiers, vPos) {
  var n = tiers.length;
  if (cartCount >= tiers[n - 1].qty) return 100;
  for (var i = 0; i < n; i++) {
    if (cartCount < tiers[i].qty) {
      var prevPos = i === 0 ? 0 : vPos[i - 1];
      var nextPos = vPos[i];
      var prevQty = i === 0 ? 0 : tiers[i - 1].qty;
      var t       = (cartCount - prevQty) / (tiers[i].qty - prevQty);
      return parseFloat((prevPos + t * (nextPos - prevPos)).toFixed(1));
    }
  }
  return 100;
}

function lpBuildDiscountHTML(cartCount, tiers, successText, prices) {
  var vPos    = lpGetVisualPositions(tiers);
  var fillPct = lpGetFillPct(cartCount, tiers, vPos);

  // Find next tier not yet reached
  var nextTier = null;
  for (var i = 0; i < tiers.length; i++) {
    if (cartCount < tiers[i].qty) { nextTier = tiers[i]; break; }
  }
  var isComplete = !nextTier;

  // Two-line message
  var msgLine1 = '', msgLine2 = '';
  if (isComplete) {
    msgLine2 = successText || ('Your ' + tiers[tiers.length - 1].text + ' discount has been applied to your cart.');
  } else {
    var needed = nextTier.qty - cartCount;
    msgLine1 = 'Add ' + needed + ' more bag' + (needed === 1 ? '' : 's');
    msgLine2 = 'for ' + nextTier.text + '!';
  }

  // Checkmark SVG — stroke is green to show on white dot background
  var checkSVG = '<svg class="lp-dp__check" width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">'
    + '<path d="M1 4.5L4.5 8L11 1" stroke="var(--lp-accent,#34d399)" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>'
    + '</svg>';

  // Milestone markers
  var markersHTML = '';
  tiers.forEach(function (tier, idx) {
    var pos     = vPos[idx];
    var reached = cartCount >= tier.qty;
    var isNext  = nextTier && nextTier.qty === tier.qty;
    var cls     = 'lp-dp__marker'
      + (reached ? ' lp-dp__marker--reached' : '')
      + (isNext  ? ' lp-dp__marker--next'    : '');
    var dotInner = reached
      ? checkSVG
      : '<span class="lp-dp__marker-num">' + (idx + 1) + '</span>';
    markersHTML += '<span class="' + cls + '" style="left:' + pos + '%">'
      + '<span class="lp-dp__marker-dot">' + dotInner + '</span>'
      + '<span class="lp-dp__marker-label">' + lpEscapeHTML(tier.text) + '</span>'
      + '</span>';
  });

  var msgHTML = isComplete
    ? '<div class="lp-dp__msg lp-dp__msg--success">'
      +   '<span class="lp-dp__msg-line2">' + lpEscapeHTML(msgLine2) + '</span>'
      + '</div>'
    : '<div class="lp-dp__msg">'
      +   '<span class="lp-dp__msg-line1">' + lpEscapeHTML(msgLine1) + '</span>'
      +   '<span class="lp-dp__msg-line2">' + lpEscapeHTML(msgLine2) + '</span>'
      + '</div>';

  // Per-bag pricing strip
  var pricesHTML = '';
  if (prices) {
    var priceItems = [];
    if (prices.basePrice) {
      priceItems.push({ label: '1 bag', price: prices.basePrice, minQty: 1, maxQty: tiers.length ? tiers[0].qty : Infinity });
    }
    tiers.forEach(function (tier, i) {
      var p = prices['t' + (i + 1) + 'Price'];
      if (p) {
        priceItems.push({
          label: tier.qty + ' bag' + (tier.qty !== 1 ? 's' : ''),
          price: p,
          minQty: tier.qty,
          maxQty: i < tiers.length - 1 ? tiers[i + 1].qty : Infinity
        });
      }
    });
    if (priceItems.length > 0) {
      // Determine active pill: highest tier reached (or base if 1+ in cart)
      var activePillIdx = -1;
      if (cartCount >= 1) activePillIdx = 0;
      for (var pi = 0; pi < tiers.length; pi++) {
        if (cartCount >= tiers[pi].qty && pi + 1 < priceItems.length) activePillIdx = pi + 1;
      }
      var pillsHTML = priceItems.map(function (item, idx) {
        var isActive = idx === activePillIdx;
        var cls = 'lp-dp__price-pill' + (isActive ? ' lp-dp__price-pill--active' : '');
        return '<span class="' + cls + '">'
          + '<span class="lp-dp__price-qty">' + lpEscapeHTML(item.label) + '</span>'
          + '<span class="lp-dp__price-sep">·</span>'
          + '<span class="lp-dp__price-val">' + lpEscapeHTML(item.price) + '</span>'
          + (item.minQty > 1 ? '<span class="lp-dp__price-each"> ea</span>' : '')
          + '</span>';
      }).join('');
      pricesHTML = '<div class="lp-dp__prices">' + pillsHTML + '</div>';
    }
  }

  return '<div class="lp-dp' + (isComplete ? ' lp-dp--complete' : '') + '">'
    + '<div class="lp-dp__bar">'
    +   '<div class="lp-dp__fill" style="width:0" data-lp-fill-target="' + fillPct + '"></div>'
    +   markersHTML
    + '</div>'
    + msgHTML
    + pricesHTML
    + '</div>';
}

function lpUpdateDiscountBanner(cart) {
  var targets = document.querySelectorAll('[data-lp-discount-target]');
  if (!targets.length) return;

  targets.forEach(function (el) {
    var rawIds      = el.getAttribute('data-product-ids') || '';
    var productIds  = rawIds.split(',').map(Number).filter(Boolean);
    var successText = (el.getAttribute('data-success-text') || '').trim();

    var t1Qty = parseInt(el.getAttribute('data-tier1-qty'), 10) || 0;
    var t1Txt = (el.getAttribute('data-tier1-text') || '').trim();
    var t2Qty = parseInt(el.getAttribute('data-tier2-qty'), 10) || 0;
    var t2Txt = (el.getAttribute('data-tier2-text') || '').trim();
    var t3Qty = parseInt(el.getAttribute('data-tier3-qty'), 10) || 0;
    var t3Txt = (el.getAttribute('data-tier3-text') || '').trim();

    var prices = {
      basePrice: (el.getAttribute('data-base-price') || '').trim(),
      t1Price:   (el.getAttribute('data-tier1-price') || '').trim(),
      t2Price:   (el.getAttribute('data-tier2-price') || '').trim(),
      t3Price:   (el.getAttribute('data-tier3-price') || '').trim()
    };

    // Snapshot original description HTML on first call
    if (!el.hasAttribute('data-original-html')) {
      el.setAttribute('data-original-html', el.innerHTML);
    }
    var originalHTML = el.getAttribute('data-original-html');

    // Build active tiers
    var tiers = [];
    if (t1Qty > 0 && t1Txt) tiers.push({ qty: t1Qty, text: t1Txt });
    if (t2Qty > 0 && t2Txt) tiers.push({ qty: t2Qty, text: t2Txt });
    if (t3Qty > 0 && t3Txt) tiers.push({ qty: t3Qty, text: t3Txt });
    tiers.sort(function (a, b) { return a.qty - b.qty; });

    if (!tiers.length) { return; }

    // Count qualifying items in cart
    var cartCount = 0;
    if (cart && cart.items) {
      cart.items.forEach(function (item) {
        if (!productIds.length || productIds.indexOf(Number(item.product_id)) !== -1) {
          cartCount += item.quantity;
        }
      });
    }

    // Always show the progress bar — re-render whenever cart count changes
    var stateKey = String(cartCount);
    if (el.getAttribute('data-discount-state') !== stateKey) {
      el.setAttribute('data-discount-state', stateKey);
      el.innerHTML = lpBuildDiscountHTML(cartCount, tiers, successText, prices);
      el.classList.add('lp-products__description--discount');
      // Double-RAF: let the browser paint the element at width:0,
      // then set the target width so the CSS transition fires cleanly.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var fill = el.querySelector('[data-lp-fill-target]');
          if (fill) fill.style.width = fill.getAttribute('data-lp-fill-target') + '%';
        });
      });
    }
  });
}

/* ── Cart count sync ── */

function lpSyncCartCount() {
  return fetch(lpGetCartUrl() + '.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      lpUpdateCartCount(cart.item_count);
      lpSyncProductQuantities(cart);
      lpUpdateDiscountBanner(cart);
      return cart;
    })
    .catch(function () {});
}

/* ── Cart drawer ── */

function lpShowCartHasItemsState() {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  drawer.classList.remove('is-empty');
  drawer.querySelectorAll('.cart-drawer__warnings, .cart-drawer__empty-content').forEach(function (el) {
    el.setAttribute('hidden', '');
    el.style.display = 'none';
  });
  drawer.querySelectorAll('#CartDrawer-Form, #CartDrawer-CartItems, .cart-drawer__footer').forEach(function (el) {
    el.removeAttribute('hidden');
    el.style.display = '';
  });
}

function lpOpenCartDrawer(btn, hasItems) {
  var drawer = document.querySelector('cart-drawer') ||
               document.querySelector('#CartDrawer') ||
               document.querySelector('[data-cart-drawer]');

  if (!drawer) { window.location.href = lpGetCartUrl(); return; }

  if (hasItems) {
    drawer.classList.remove('is-empty');
    lpShowCartHasItemsState();
  }

  if (typeof drawer.open === 'function') {
    drawer.open(btn);
  } else {
    drawer.removeAttribute('hidden');
    drawer.setAttribute('open', '');
  }
}

function lpRefreshCartDrawer(btn, state) {
  var cartDrawer     = document.querySelector('cart-drawer');
  var shouldShowItems = !state || state.item_count == null || state.item_count > 0;

  if (cartDrawer && typeof cartDrawer.renderContents === 'function' && state && state.sections) {
    cartDrawer.renderContents(state);
    if (shouldShowItems) lpShowCartHasItemsState();
    requestAnimationFrame(function () {
      if (shouldShowItems) lpShowCartHasItemsState();
    });
  } else if (cartDrawer && state && state.sections && state.sections['cart-drawer']) {
    var drawerDoc    = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
    var newItems     = drawerDoc.querySelector('#CartDrawer-CartItems');
    var existingItems = document.querySelector('#CartDrawer-CartItems');
    var newFooter    = drawerDoc.querySelector('.cart-drawer__footer');
    var existingFooter = document.querySelector('.cart-drawer__footer');

    if (newItems && existingItems)     existingItems.innerHTML = newItems.innerHTML;
    if (newFooter && existingFooter)   existingFooter.innerHTML = newFooter.innerHTML;
    if (shouldShowItems) lpShowCartHasItemsState();
    requestAnimationFrame(function () { lpOpenCartDrawer(btn, shouldShowItems); });
  }

  return fetch(lpGetCartUrl() + '.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      lpUpdateCartCount(cart.item_count, state && state.sections && state.sections['cart-icon-bubble']);
      lpSyncProductQuantities(cart);
      lpUpdateDiscountBanner(cart);
      if (cart.item_count > 0) lpShowCartHasItemsState();
      requestAnimationFrame(function () {
        if (cart.item_count > 0) lpShowCartHasItemsState();
        lpOpenCartDrawer(btn, cart.item_count > 0);
      });
      return cart;
    });
}

/* ── Change quantity ── */

function lpChangeProductQuantity(btn, delta) {
  var control   = btn.closest('[data-lp-cart-controls]');
  if (!control) return;

  var variantId = Number(control.getAttribute('data-variant-id'));
  if (!variantId) return;

  lpSetProductControlsLoading(control, true);

  fetch(lpGetCartUrl() + '.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var item          = lpFindCartItem(cart, variantId);
      var currentQty    = item ? item.quantity : 0;
      var nextQty       = Math.max(0, currentQty + delta);

      // Use the line item key (not the variant ID) — required by /cart/change.js
      var itemKey = item ? item.key : null;

      if (!itemKey) {
        // Item is not in the cart yet; if incrementing, add it instead
        if (delta > 0) {
          lpSetProductControlsLoading(control, false);
          var fakeBtn = control.querySelector('.lp-btc-card__atc, .lp-product-card__cta');
          if (fakeBtn) lpAddToCart(fakeBtn, variantId);
        } else {
          lpSetProductControlsLoading(control, false);
        }
        return Promise.resolve();
      }

      return fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id:           itemKey,
          quantity:     nextQty,
          sections:     lpGetSectionsToRender(),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('quantity change failed: ' + r.status);
          return r.json();
        })
        .then(function (state) {
          return lpRefreshCartDrawer(btn, state);
        });
    })
    .catch(function (err) {
      console.error('[lpChangeProductQuantity]', err);
      return lpSyncCartCount();
    })
    .then(function () {
      lpSetProductControlsLoading(control, false);
    });
}

/* ── Add to cart ── */

function lpAddToCart(btn, variantId) {
  if (!variantId || btn.disabled) return;

  var control     = btn.closest('[data-lp-cart-controls]');
  var originalHTML = btn.innerHTML;
  btn.disabled    = true;
  btn.innerHTML   = 'Adding\u2026';

  fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      id:           variantId,
      quantity:     1,
      sections:     lpGetSectionsToRender(),
      sections_url: window.location.pathname
    })
  })
    .then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    })
    .then(function (state) {
      btn.innerHTML = 'Added!';
      lpSetProductQuantityUI(variantId, 1);
      return lpRefreshCartDrawer(btn, state);
    })
    .catch(function (err) {
      console.error('[lpAddToCart] Ajax add failed:', err);
      return fetch(lpGetCartUrl() + '.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.item_count > 0) {
            lpUpdateCartCount(cart.item_count);
            window.location.href = lpGetCartUrl();
            return;
          }
          throw err;
        });
    })
    .then(function () {
      setTimeout(function () {
        btn.innerHTML = originalHTML;
        btn.disabled  = false;
        if (control) lpSetProductControlsLoading(control, false);
      }, 2000);
    })
    .catch(function (err) {
      console.error('[lpAddToCart] Failed:', err);
      btn.innerHTML = 'Error — try again';
      btn.disabled  = false;
      setTimeout(function () { btn.innerHTML = originalHTML; }, 2000);
    });
}

/* ── On remove from drawer, re-sync ── */

document.addEventListener('click', function (event) {
  if (event.target.closest('cart-remove-button, [aria-label^="Remove"], a[href*="/cart/change"], button[name="remove"]')) {
    setTimeout(lpSyncCartCount, 700);
    setTimeout(lpSyncCartCount, 1500);
    setTimeout(lpSyncCartCount, 3000);
  }
});

/* ── Init: restore stepper state on page load ── */

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    lpUpdateDiscountBanner(null); // render bar immediately at 0 items
    lpSyncCartCount();            // then sync real cart state
  });
} else {
  lpUpdateDiscountBanner(null);
  lpSyncCartCount();
}
